export enum EnumTipoNotificacion {
  EnvioPostal = 1,
  EnvioCorreoElectronico = 2,
  Ambos = 3,
  TuComunidad = 4,
  Face = 5,
  Conecta = 6,
  TAAF = 7
}
